const GetUserToken = () => {
    const tokenJsonString = localStorage.getItem('token');
    const tokenJsonObject = JSON.parse(tokenJsonString);
    const tokenJsonCode = tokenJsonObject.token;
    return tokenJsonCode;
}

export default GetUserToken;
